import { Loadable } from 'loankeeper-common/components/hocs/LazyLoading'
import { createNavigationConfig } from 'loankeeper-common/components'
// @ts-ignore
import { OPERATION_DAY_MODAL } from './constants'

const OperationDay = Loadable(() => import('./OperationDay'))

export const createOperationDayNavigationItem = createNavigationConfig((translateFn) => ({
  icon: 'clock',
  text: translateFn('mnu_other_operating_day'),
  identity: OPERATION_DAY_MODAL,
  oneOfPermissions: ['OPEN_DAY', 'CLOSE_DAY', 'OPEN_DAY_ACCONLY ', 'CLOSE_DAY_ACCONLY'],
  component: OperationDay,
}))

export default OperationDay
